if (!customElements.get('campaign-countdown')) {
  customElements.define(
    'campaign-countdown',
    class CampaignCountdown extends HTMLElement {
      connectedCallback() {
        this.units = this.querySelector('[data-units]');
        this.finished = this.querySelector('[data-finished]');
        this.end = this.resolveEndTime();
        if (this.dataset.invalid === 'true') {
          this.end = 0;
          if (this.units) this.units.hidden = true;
          return;
        }
        if (!this.end && this.dataset.preview === 'true') {
          this.end = Date.now() + 36 * 60 * 60 * 1000;
        }
        this.tick();
        if (this.end > Date.now()) {
          this.interval = setInterval(() => this.tick(), 1000);
        }
      }

      disconnectedCallback() {
        if (this.interval) clearInterval(this.interval);
      }

      resolveEndTime() {
        const fromUnix = Number(this.dataset.end || 0) * 1000;
        return fromUnix || 0;
      }

      tick() {
        if (!this.end) return;

        const remaining = Math.max(0, this.end - Date.now());
        if (remaining <= 0) {
          this.complete();
          return;
        }

        const totalSeconds = Math.floor(remaining / 1000);
        const days = Math.floor(totalSeconds / 86400);
        const hours = Math.floor((totalSeconds % 86400) / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        this.setUnit('days', days);
        this.setUnit('hours', hours);
        this.setUnit('minutes', minutes);
        this.setUnit('seconds', seconds);
      }

      setUnit(name, value) {
        const el = this.querySelector(`[data-unit="${name}"]`);
        if (el) el.textContent = String(value).padStart(2, '0');
      }

      complete() {
        if (this.interval) {
          clearInterval(this.interval);
          this.interval = null;
        }
        if (this.dataset.hideWhenFinished === 'true' && !(window.Shopify && Shopify.designMode)) {
          const section = this.closest('.shopify-section');
          if (section) section.hidden = true;
          return;
        }
        if (this.units) this.units.hidden = true;
        if (this.finished && this.finished.textContent.trim() !== '') {
          this.finished.hidden = false;
        }
      }
    }
  );
}
